import React, { useEffect, useRef } from "react";

// Renders a Leaflet map with markers for the given points.
// points: [{ lat, lng, label, sub }]
export default function AttendanceMap({ points = [] }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const L = window.L;
    if (!L || !ref.current) return;
    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { scrollWheelZoom: true });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap",
        maxZoom: 19,
      }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    // clear existing markers
    map.eachLayer((layer) => {
      if (layer instanceof L.Marker) map.removeLayer(layer);
    });
    const valid = points.filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
    if (valid.length === 0) {
      map.setView([20.5937, 78.9629], 4); // India
      return;
    }
    const bounds = [];
    valid.forEach((p) => {
      const m = L.marker([p.lat, p.lng]).addTo(map);
      m.bindPopup(`<b>${p.label || ""}</b><br/>${p.sub || ""}`);
      bounds.push([p.lat, p.lng]);
    });
    if (bounds.length === 1) map.setView(bounds[0], 15);
    else map.fitBounds(bounds, { padding: [30, 30] });
    setTimeout(() => map.invalidateSize(), 200);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [points]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } }, []);

  return <div ref={ref} data-testid="attendance-map" style={{ height: "60vh", width: "100%", borderRadius: 12 }} />;
}
